"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function HomeHeader() {
  return <ResponsiveHeader />
}
